export const TERMS_VERSION = '1.0';
export const TERMS_EFFECTIVE_DATE = '2026-03-14';
